import { render, staticRenderFns } from "./emailDetail.vue?vue&type=template&id=20134868&"
import script from "./emailDetail.vue?vue&type=script&lang=js&"
export * from "./emailDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports